import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

const V = '#8B5CF6';
const VL = '#EDE9FE';

const STATUS_STEPS = ['pending', 'confirmed', 'processing', 'shipped', 'delivered'];
const STATUS_LABELS = {
  pending:    { l: 'En attente',     icon: '🕐', color: '#F59E0B' },
  confirmed:  { l: 'Confirmée',      icon: '✅', color: '#10B981' },
  processing: { l: 'En préparation', icon: '📦', color: '#3B82F6' },
  shipped:    { l: 'Expédiée',       icon: '🚚', color: '#8B5CF6' },
  delivered:  { l: 'Livrée',         icon: '🎉', color: '#10B981' },
  cancelled:  { l: 'Annulée',        icon: '❌', color: '#EF4444' },
};

export default function OrderTrackingPage() {
  const [orderNum, setOrderNum] = useState('');
  const [email,    setEmail]    = useState('');
  const [order,    setOrder]    = useState(null);
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setOrder(null);
    try {
      const res = await api.get(`/api/orders/track`, { params: { orderNumber: orderNum, email } });
      setOrder(res.data);
    } catch (err) {
      setError(err.response?.data?.message || 'Commande introuvable. Vérifiez le numéro et l\'email.');
    } finally {
      setLoading(false);
    }
  };

  const stepIndex = order ? STATUS_STEPS.indexOf(order.status) : -1;
  const isCancelled = order?.status === 'cancelled';

  return (
    <div style={{ background: '#fff', minHeight: '100vh', color: '#111' }}>
      {/* Header */}
      <div style={{ background: 'linear-gradient(135deg, #6D28D9, #8B5CF6)', padding: '3rem 2rem', textAlign: 'center' }}>
        <p style={{ fontSize: 10, letterSpacing: 4, color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', marginBottom: 8 }}>SS PARFUMERIE</p>
        <h1 style={{ fontFamily: 'Georgia, serif', fontSize: 40, fontWeight: 300, color: '#fff', marginBottom: 8 }}>Suivi de commande</h1>
        <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.75)' }}>Entrez votre numéro de commande pour suivre votre colis</p>
      </div>

      <div style={{ maxWidth: 640, margin: '0 auto', padding: '3rem 2rem' }}>

        {/* Formulaire de recherche */}
        <form onSubmit={handleSearch} style={{ background: '#FAFAFE', border: '1px solid #EDE9FE', borderRadius: 12, padding: '2rem', marginBottom: 32 }}>
          <p style={{ fontSize: 10, letterSpacing: 2, color: V, textTransform: 'uppercase', marginBottom: 20, fontWeight: 600 }}>Rechercher une commande</p>
          <div style={{ display: 'grid', gap: 12, marginBottom: 20 }}>
            <input
              placeholder="Numéro de commande (ex: ELX-1001)"
              value={orderNum}
              onChange={e => setOrderNum(e.target.value.toUpperCase())}
              style={{ background: '#fff', border: '1px solid #DDD6FE', color: '#111', padding: '14px 16px', fontSize: 14, outline: 'none', borderRadius: 6, width: '100%', boxSizing: 'border-box' }}
              required
            />
            <input
              type="email"
              placeholder="Email de la commande"
              value={email}
              onChange={e => setEmail(e.target.value)}
              style={{ background: '#fff', border: '1px solid #DDD6FE', color: '#111', padding: '14px 16px', fontSize: 14, outline: 'none', borderRadius: 6, width: '100%', boxSizing: 'border-box' }}
              required
            />
          </div>
          <button type="submit" disabled={loading} style={{
            width: '100%', background: loading ? '#A78BFA' : V, color: '#fff', border: 'none',
            padding: '14px', fontSize: 12, letterSpacing: 3, textTransform: 'uppercase',
            cursor: 'pointer', borderRadius: 6, transition: 'background .2s'
          }}>
            {loading ? 'Recherche en cours...' : 'Rechercher'}
          </button>
          {error && <p style={{ marginTop: 12, fontSize: 13, color: '#EF4444', textAlign: 'center' }}>{error}</p>}
        </form>

        {/* Résultat */}
        {order && (
          <div>
            {/* Résumé commande */}
            <div style={{ background: '#FAFAFE', border: '1px solid #EDE9FE', borderRadius: 12, padding: '1.5rem', marginBottom: 24 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
                <div>
                  <p style={{ fontFamily: 'Georgia, serif', fontSize: 20, color: V }}>{order.orderNumber}</p>
                  <p style={{ fontSize: 12, color: '#888', marginTop: 4 }}>
                    {new Date(order.createdAt).toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
                  </p>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <p style={{ fontFamily: 'Georgia, serif', fontSize: 20, color: V }}>{order.total} FCFA</p>
                  <span style={{ fontSize: 11, background: STATUS_LABELS[order.status]?.color + '20', color: STATUS_LABELS[order.status]?.color, padding: '2px 10px', borderRadius: 4 }}>
                    {STATUS_LABELS[order.status]?.icon} {STATUS_LABELS[order.status]?.l}
                  </span>
                </div>
              </div>
              {/* Articles */}
              {order.items?.map((item, i) => (
                <div key={i} style={{ fontSize: 13, color: '#666', padding: '6px 0', borderTop: '1px solid #EEE' }}>
                  {item.name} · {item.size}ml × {item.quantity}
                </div>
              ))}
            </div>

            {/* Timeline statut */}
            {!isCancelled && (
              <div style={{ background: '#FAFAFE', border: '1px solid #EDE9FE', borderRadius: 12, padding: '1.5rem', marginBottom: 24 }}>
                <p style={{ fontSize: 10, letterSpacing: 2, color: V, textTransform: 'uppercase', marginBottom: 24, fontWeight: 600 }}>Progression</p>
                <div style={{ position: 'relative' }}>
                  {/* Barre de progression */}
                  <div style={{ position: 'absolute', top: 20, left: 20, right: 20, height: 2, background: '#EEE' }}>
                    <div style={{ height: '100%', background: V, width: `${stepIndex >= 0 ? (stepIndex / (STATUS_STEPS.length - 1)) * 100 : 0}%`, transition: 'width 0.5s' }} />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', position: 'relative' }}>
                    {STATUS_STEPS.map((s, i) => {
                      const done = i <= stepIndex;
                      const lbl = STATUS_LABELS[s];
                      return (
                        <div key={s} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
                          <div style={{ width: 40, height: 40, borderRadius: '50%', background: done ? V : '#EEE', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, marginBottom: 10, border: `2px solid ${done ? V : '#DDD'}`, transition: 'all 0.3s', zIndex: 1 }}>
                            {done ? lbl.icon : '○'}
                          </div>
                          <p style={{ fontSize: 9, color: done ? V : '#AAA', letterSpacing: 1, textTransform: 'uppercase', textAlign: 'center', lineHeight: 1.4 }}>{lbl.l}</p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}

            {/* Adresse livraison */}
            {order.shippingAddress && (
              <div style={{ background: '#FAFAFE', border: '1px solid #EDE9FE', borderRadius: 12, padding: '1.5rem', marginBottom: 24 }}>
                <p style={{ fontSize: 10, letterSpacing: 2, color: V, textTransform: 'uppercase', marginBottom: 12, fontWeight: 600 }}>Adresse de livraison</p>
                <p style={{ fontSize: 14, lineHeight: 1.7, color: '#555' }}>
                  {order.shippingAddress.nom}<br />
                  {order.shippingAddress.rue}<br />
                  {order.shippingAddress.ville} {order.shippingAddress.codePostal}<br />
                  {order.shippingAddress.pays}
                </p>
                {order.trackingNumber && (
                  <p style={{ marginTop: 12, fontSize: 13, color: V, fontWeight: 600 }}>N° suivi : {order.trackingNumber}</p>
                )}
              </div>
            )}

            <div style={{ textAlign: 'center' }}>
              <Link to="/catalogue" style={{ color: V, fontSize: 13, textDecoration: 'none' }}>← Continuer mes achats</Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
